module.exports = __webpack_public_path__ + "static/media/woohoo.6a9d3623.png";